import { Button, Modal } from 'antd';
import { t } from 'i18next';
import parse from 'html-react-parser';
import IconQuestion from '../../../assets/Images/icons/icon-question';

const ModalDiscardChanges = ({
    open,
    title = t('common.DiscardChanges'),
    text = t('common.DiscardChangesText'),
    handelClose,
    handelOk,
    loading,
    isConfirm = true,
    icon = <IconQuestion />,
}) => {
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                {icon}
                <div className="text-2xl font-semibold">{title}</div>
                <div>{parse(text)}</div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                {isConfirm ? (
                    <>
                        <Button
                            type="primary"
                            onClick={handelOk}
                            size="large"
                            ghost
                            className="w-36"
                        >
                            {t('Discard')}
                        </Button>
                        <Button
                            loading={loading}
                            onClick={handelClose}
                            size="large"
                            type="primary"
                            className="w-36"
                        >
                            {t('Keep editing')}
                        </Button>
                    </>
                ) : (
                    <Button onClick={handelClose} size="large" type="primary">
                        {t('common.Close')}
                    </Button>
                )}
            </div>
        </Modal>
    );
};
export default ModalDiscardChanges;
